export default "__VITE_PUBLIC_ASSET__0263ba0d__"